import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
import Pastille from '~/components/atoms/Global/Pastille.vue';
export default {
  name: 'OfferPastille',
  components: {
    Pastille: Pastille
  },
  props: {
    payload: {
      type: Array,
      required: true
    }
  },
  computed: {
    pastilles: function pastilles() {
      return this.payload.filter(function (p) {
        return p.price;
      });
    }
  }
};